module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chaptitle"
  }, [_vm._v("Century Club, New York City, 2001")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“You must be thinking that Clayton was not exactly a man of the people,” Danforth said with an arid chuckle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He does seem very old-school,” I admitted. “But the intelligence agency recruited pretty much exclusively from those ranks back then, didn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, it did,” Danforth said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The good news is that our boys weren’t like those upper-class Brits who ended up so disloyal, spying for Mother Russia,” I added. “Philby, Burgess, and the rest. Traitors all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And all equally to be condemned,” Danforth said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course,” I agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Even if they believed in their cause?” Danforth asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wouldn’t care what they believed,” I answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Danforth’s gaze betrayed a curious complexity, as if the memory of something won or lost had suddenly returned to him. "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("“Indeed,” he said softly, as if reviewing an old decision or coming to a new one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course, most of them were fools,” I said, determined to show Danforth that I knew my espionage history, could recite a few details. “The Cambridge Five. Imagine that group, dashing around Europe, delivering a codebook on Gibraltar, like Philby did.” I laughed derisively. “They always struck me as buffoons.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Or posing as such,” Danforth said. “There is a lot of acting in this business. Pretending to be afraid. Pretending to be brave. Even pretending to be in love.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That would be a cruel pretense, wouldn’t it?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, it would,” Danforth answered firmly. “Perhaps as cruel as pretending to believe in something when you actually believe the opposite.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I sensed that this last remark had returned Danforth to his subject.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Did Clayton believe in whatever he was doing?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Clayton believed absolutely in what he was doing,” Danforth answered. “There was never anything confused or addled about him, nothing in disarray.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not like that woman in the bar, then,” I said, to demonstrate that I’d been listening closely to his tale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Danforth said, “nothing like that woman in the bar. Who walked straight to the rear of the place that night, by the way.” His gaze grew distant, a man sinking back into the past. “As a matter of fact, she came so close to me a clump of snow fell off her coat and landed on mine.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e982168","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Pt1Ch5.vue
// module id = 93
// module chunks = 0